// @flow
import BaseModel from 'Stores/BaseModel';
import AssetModel from 'Stores/AssetModel';

type Price = {
  price: number,
  priceText: string,
  footnote: string,
  pricePrefix: string,
};

type Cta = {
  additional: string,
  buttonVariant: 'primary' | 'secondary' | 'tertiary',
  class: string,
  href: string,
  label: string,
  mazdaForm: boolean,
  model: string,
  target: '_self' | '_top' | '_parent' | '_blank',
  theme: 'primary' | 'secondary',
  trackingLabel: string,
};

export class ServiceOfferModel extends BaseModel {
  bodyText: string = '';
  footnote: string = '';
  header1: string = '';
  header2: string = '';
  headlineLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  id: number = 0;
  image: ?AssetModel = null;
  modalType: 'OSB' | 'OSR';
  price: string = '';
  priceInfo: string = '';
  sorting: number = 0;
  tireDataSheet: ?{
    enabled: boolean,
    image: ?AssetModel,
    label: string,
    url: string,
  };

  constructor(data: Object = {}) {
    super();
    this.hydrate(data);

    this.image = this.image ? new AssetModel(this.image) : null;
    this.copy = data.bodyText;
    this.bodyText = data.copy;
    this.headline1 = data.header1;
    this.headline2 = data.header2;
    this.headlineLevel = data.headlineLevel;
    this.tireDataSheet = data.tireDataSheet;
    this.modalType = data.modalType;
  }
}

export default class OfferModel extends BaseModel {
  id: number = 0;
  sorting: number = 0;
  parentId: ?number = null;
  hidden: boolean = true;
  custom: boolean = true;
  offerType: string = 'PRIVATE';
  offerSubtype: string = null;
  customerBenefitPrice: number = -1;
  customerBenefitPriceText: string = '';
  carlineDeeplink: string = '';
  modelDescription: string = '';
  consumptionInfoDescription: string = '';
  range: number = 0;
  image: ?AssetModel = null;
  starttime: ?Date = new Date();
  cashPrice: Price = {
    price: 0,
    priceText: '',
    footnote: '',
    pricePrefix: '',
  };
  leftPrice: Price = {
    price: 0,
    priceText: '',
    footnote: '',
    pricePrefix: '',
  };
  rightPrice: Price = {
    price: 0,
    priceText: '',
    footnote: '',
    pricePrefix: '',
  };
  cta1: ?Cta = null;
  cta2: ?Cta = null;
  bodyText: string = '';
  headline: ?{
    forceUppercase: boolean,
    level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
    value: string | React$Node,
  };

  constructor(data: Object = {}) {
    super();
    this.hydrate(data);

    this.image = this.image ? new AssetModel(this.image) : null;
    this.headline = data.headline;
  }
}
